import { get, omit } from 'lodash-es';

import EditIcon from '@mui/icons-material/Edit';
import Icon from '@mui/material/Icon';
import InputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

const StyledTextField = styled(({ ...other }) => <TextField {...omit(other, 'backgroundField')} />)(
  ({ theme, backgroundField }) => ({
    fontSize: 14,
    '& .MuiInputBase-root': {
      background: backgroundField
        ? theme?.palette?.booking?.backgroundField
        : theme?.palette?.common?.white
    },
    '& .MuiIcon-root': { color: theme.palette.primary.light }
  })
);

const TextInput = ({
  field = {}, // { name, value, onChange, onBlur }
  form: { touched, errors } = {},
  icon = <EditIcon />,
  isIcon = false,
  size = 'small',
  variant = 'outlined',
  required,
  type = 'text',
  maxLength = null,
  backgroundField = true,
  ...rest
}) => {
  return (
    <StyledTextField
      autoComplete='off'
      size={size}
      type={type}
      variant={variant}
      backgroundField={backgroundField}
      error={Boolean(get(touched, field?.name) && get(errors, field?.name))}
      helperText={get(touched, field?.name) && get(errors, field?.name)}
      inputProps={{ maxLength }}
      InputProps={{
        endAdornment: icon ? (
          <InputAdornment position='end'>{isIcon && <Icon>{icon}</Icon>}</InputAdornment>
        ) : null
      }}
      {...field}
      {...rest}
      required={required}
      FormHelperTextProps={{ ['data-test-id']: field?.name }}
    />
  );
};

export default TextInput;
